import { Component, OnInit, Output, EventEmitter, Input, OnChanges } from '@angular/core';

@Component({
    selector: 'ngx-paginator-template',
    templateUrl: './ngx-paginator-template.html',
    styles:['li.disabled { pointer-events: none; }']
})
export class NgxPaginatorTemplate implements OnInit {
    public pageNumber: number = 1;
    @Output() GET_PAGE = new EventEmitter();
    @Input() showLast: boolean = true;
    constructor() { }

    ngOnInit() {
 
    }

    getPage(page) {
        this.pageNumber = page;
        this.GET_PAGE.emit(page);
    }



}



// WEBPACK FOOTER //
// ./src/app/pages/shared/components/ngx-paginator-template/ngx-paginator-template.component.ts